<div class="wrapper">
  <div id="sidebar">
    <app-side-navbar></app-side-navbar>
  </div>
  <div id="content" [class.nav-minimized]="isMinimized">
    <router-outlet></router-outlet>
  </div>
</div>
